var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"search-bar"},[_c('former-input',{ref:"input",staticClass:"search-bar-input",attrs:{"field":_vm.field,"value":_vm.value,"autofocus":_vm.autofocus,"focusless":""},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }